import { ENUM_MortgageType, ENUM_PropertyInvestmentType, HTTP_Pagination_Request } from '@api-new/common';
import { HTTP_CP_MatchMortgageProducts_Request } from '@api-new/mortgageservice';
import { dateToIsoStringWithoutTimezone } from '@shared-lib/utils/date-utils/date-to-iso-string-without-timezone';
import { MortgagePartFormValues } from '../../../../mortgage-part.form';
import { MortgageFormProductMatchingInfoModel } from '../../../models/mortgage-form-product-matching-info.model';

export const productMatchingInfoToRequestAdapter = (
  productMatchingInfo: MortgageFormProductMatchingInfoModel,
  mortgagePart: MortgagePartFormValues | null,
  pagination: HTTP_Pagination_Request,
): HTTP_CP_MatchMortgageProducts_Request => {
  const currentInterestRate = productMatchingInfo?.singlePartRate
    ? productMatchingInfo.singlePartRate / 100
    : (mortgagePart?.initialInterestRate ?? undefined);
  return {
    mortgageLenderId: productMatchingInfo.lenderId,
    propertyCurrentValueAsOwnershipShare: productMatchingInfo.propertyCurrentValueAsOwnershipShare,
    mortgageType:
      productMatchingInfo.propertyInvestmentType === ENUM_PropertyInvestmentType.PROPERTY_INVESTMENT_TYPE_RESIDENTIAL
        ? ENUM_MortgageType.MORTGAGE_TYPE_RESIDENTIAL
        : ENUM_MortgageType.MORTGAGE_TYPE_BUY_TO_LET,
    mortgageTotalInitialAmount: productMatchingInfo.mortgageTotalInitialAmount,
    mortgagePart: mortgagePart
      ? {
          startDate: dateToIsoStringWithoutTimezone(mortgagePart.startDate) ?? undefined,
          repaymentType: mortgagePart.repaymentType,
          initialAmount: mortgagePart.borrowedAmount,
          termMonths: mortgagePart.term,
          initialMortgagePartStepType: mortgagePart.initialRateType ?? undefined,
          initialMortgagePartStepTermMonths: mortgagePart.initialRatePeriod,
          ...(productMatchingInfo.singlePartMonthlyPayment
            ? { currentMonthlyPayment: productMatchingInfo.singlePartMonthlyPayment }
            : { currentInterestRate: currentInterestRate }),
        }
      : undefined,
    pagination,
  };
};
